import { Blocs } from '@business/blocs';
import { ContactActivityRequest, ContactId } from '@business/entities/contact';
import { OrgId } from '@business/entities/organization';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { BehaviorSubject, forkJoin, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { TimelineFormData } from './NotesTimeline';
export class NotesTimelineBloc extends BaseBloc {
  private readonly contactBloc = resolve(Blocs.contact);
  private readonly activityBloc = resolve(Blocs.contactActivity);
  private readonly userBloc = resolve(Blocs.user);

  constructor(
    private orgId?: OrgId,
    private loadContacts?: boolean,
    private type?: string,
    private objectId?: string,
    private contactId?: ContactId,
    private loadOrg?: boolean,
    private showAll?: boolean,
  ) {
    super();
  }

  loading = new LoadingState();
  hasMore$ = new BehaviorSubject<boolean>(true);

  readonly activities$ = this.activityBloc.activities$.pipe(
    map(items =>
      items.filter(i => {
        return true;
      }),
    ),
  );

  readonly contacts$ = this.contactBloc.contacts$;
  readonly users$ = this.userBloc.staff$;

  filters$ = new BehaviorSubject<TimelineFormData>({ users: [], contacts: [], types: [] });

  //.fetchActivities({ orgId: this.orgId, type: this.type, objectId: this.objectId, contactId: this.contactId })
  onInit() {
    return forkJoin([
      this.loadContacts ? this.contactBloc.fetchContacts({ orgId: this.orgId }) : of(null),
      this.fetchFn(1),
      this.userBloc.fetchUsers(),
    ]).pipe(this.loading.run());
  }

  fetchFn(page?: number, createdAt?: number) {
    if (page === 1 || !page) {
      this.hasMore$.next(true);
    }
    return this.activityBloc
      .fetchActivities({
        orgId: !this.loadOrg ? undefined : this.orgId,
        type: this.type,
        objectId: this.objectId,
        contactId: this.contactId,
        page: page ? page : 1,
        filterUsers: this.filters$.value.users,
        filterTypes: this.filters$.value.types,
        filterContacts: this.filters$.value.contacts,
        showAll: this.showAll ? true : false,
        createdAt,
      })
      .pipe(
        tap(items => this.hasMore$.next(items.length > 0)),
        this.loading.run(),
      );
  }

  onReload(page?: number, createdAt?: number) {
    return this.fetchFn(page, createdAt).subscribe();
  }

  createActivity = (request: ContactActivityRequest) => this.activityBloc.createActivity(request).pipe(this.loading.run());

  updateActivity = this.activityBloc.updateActivity;
  deleteActivity = this.activityBloc.deleteActivity;
  onTogglePin = this.activityBloc.onTogglePin;
  onTogglePinEmail = this.activityBloc.onTogglePinEmail;
}
